import {FC, RefObject, useEffect} from 'react';
import {Button} from '@gravity-ui/uikit';
import block from 'bem-cn-lite';
import {ArrowUp} from '@gravity-ui/icons';

import './ScrollUpButton.scss';

const b = block('scroll-button');

interface ScrollUpBtnProps {
    targetRef?: RefObject<HTMLDivElement>;
    hiddenBtn: boolean;
    changeVisibility: (state: boolean) => void;
}

//сколько прокрутить экранов чтобы появилась кнопка
const multiplierScroll = 2;
const SCROLL_THRESHOLD_PX = 800;

export const ScrollUpButton: FC<ScrollUpBtnProps> = ({targetRef, hiddenBtn, changeVisibility}) => {
    const handleClick = () => {
        if (targetRef?.current) {
            targetRef.current.scrollTo({top: 0, behavior: 'smooth'});
        } else {
            window.scrollTo({top: 0, behavior: 'smooth'});
        }
    };

    useEffect(() => {
        const target = targetRef?.current;
        const isUsingWindow = !target;

        const handleScroll = () => {
            if (isUsingWindow) {
                const shouldShow = window.scrollY >= window.innerHeight * multiplierScroll;
                changeVisibility(!shouldShow);
            } else {
                const shouldShow = target.scrollTop >= SCROLL_THRESHOLD_PX;
                changeVisibility(!shouldShow);
            }
        };

        const scrollTarget = isUsingWindow ? window : target!;
        scrollTarget.addEventListener('scroll', handleScroll);
        handleScroll();

        return () => scrollTarget.removeEventListener('scroll', handleScroll);
    }, [targetRef]);

    return (
        <Button onClick={handleClick} view="raised" className={b({hidden: hiddenBtn})}>
            <ArrowUp />
        </Button>
    );
};
